var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3848 15.0155C6.33899 15.0155 2.88477 15.6623 2.88477 18.2466C2.88477 20.8299 6.31797 21.5 10.3848 21.5C14.4295 21.5 17.8848 20.8532 17.8848 18.2689C17.8848 15.6846 14.4516 15.0155 10.3848 15.0155Z",
    fill: "#0077CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.3845 12.5542C13.1391 12.5542 15.3471 10.3177 15.3471 7.52761C15.3471 4.73754 13.1391 2.5 10.3845 2.5C7.62994 2.5 5.42188 4.73754 5.42188 7.52761C5.42188 10.3177 7.62994 12.5542 10.3845 12.5542Z",
    fill: "#0077CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.266d44461952da024ebdfc78343faa96.svg";
export { ForwardRef as ReactComponent };